<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title
      >Beneficiary group{{ isNew ? '' : ' (' + beneficiaryGroup.status.description + ')' }}</mat-card-title
    >
    @if (beneficiaryGroup.organisationProject && !beneficiaryGroup.organisationProject.o100WeeksProject) {
      <mat-card-subtitle>
        Part of
        {{ beneficiaryGroup.organisationProject.contract.organisation.contact.name }}
        - {{ beneficiaryGroup.organisationProject.contract.name }} -
        {{ beneficiaryGroup.organisationProject.name }}
      </mat-card-subtitle>
    }
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="editForm" (ngSubmit)="save()">
      @if (isNew && !organisationProject) {
        <div>
          <app-country-autocomplete
            formControlName="country"
            [modelList]="countryList"
            (valueChanges)="countryUpdated($event)"
            autoselect
            required
          >
          </app-country-autocomplete>
        </div>
      }

      <div>
        <mat-form-field>
          <mat-label>code</mat-label>
          <input name="100w-beneficiary-group-code" formControlName="code" matInput required />
          @if (editForm.get('code')?.errors?.codeNotUnique) {
            <mat-error>
              {{ editForm.get('code')?.errors?.codeNotUnique }}
            </mat-error>
          }
          @if (editForm.get('code')?.errors?.pattern) {
            <mat-error>
              {{ editForm.get('code')?.errors?.pattern }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>local name</mat-label>
          <input name="100w-beneficiary-group-local-name" formControlName="localName" matInput />
          @if (editForm.get('localName')?.errors?.localNameNotUnique) {
            <mat-error>
              {{ editForm.get('localName')?.errors?.localNameNotUnique }}
            </mat-error>
          }
          @if (editForm.get('localName')?.errors?.maxlength) {
            <mat-error> Local name is too long </mat-error>
          }
        </mat-form-field>

        @if (!isNew) {
          <mat-form-field *ngxPermissionsOnly="roleToSeeCostCenter" formGroupName="costCenter">
            <mat-label>cost center</mat-label>
            <input name="100w-cost-center-code" formControlName="code" matInput readonly />
          </mat-form-field>
        }
      </div>

      <div>
        <app-local-partner-autocomplete
          name="100w-beneficiary-group-local-partner"
          formControlName="localPartner"
          flLabel="local partner"
          [asyncModelList]="localPartnerList"
          autoselect
          [required]="isRequired('localPartner')"
          (valueChanges)="localPartnerUpdated($event)"
        >
        </app-local-partner-autocomplete>
        <mat-form-field>
          <mat-label>province</mat-label>
          <input
            name="100w-beneficiary-group-province"
            formControlName="province"
            matInput
            [required]="isRequired('province')"
          />
        </mat-form-field>
        <mat-form-field>
          <mat-label>parish</mat-label>
          <input name="100w-beneficiary-group-parish" formControlName="parish" matInput />
        </mat-form-field>
      </div>

      <div>
        <app-contact-holder-autocomplete
          name="100w-beneficiary-group-coach"
          formControlName="coach"
          flLabel="coach"
          [asyncModelList]="coachList"
          autoselect
          [required]="isRequired('coach')"
        ></app-contact-holder-autocomplete>
        <app-field-affiliate-autocomplete
          name="100w-beneficiary-group-field-affiliate"
          [modelList]="fieldAffiliateList"
          formControlName="fieldAffiliate"
        >
        </app-field-affiliate-autocomplete>
        <mat-form-field>
          <mat-label>onboarding group size</mat-label>
          <input
            matInput
            type="number"
            name="100w-beneficiary-group-onboarding-size"
            formControlName="onboardingGroupSize"
          />
        </mat-form-field>
      </div>

      @if (!organisationProject) {
        <div>
          <app-organisation-project-autocomplete
            name="100w-beneficiary-group-organisation-project"
            [asyncModelList]="countryOrganisationProjectList"
            formControlName="organisationProject"
            [displayOrganisationName]="true"
            [required]="isRequired('organisationProject')"
            (valueChanges)="projectUpdated($event)"
          >
          </app-organisation-project-autocomplete>
          <app-watch-profile-autocomplete
            name="100w-beneficiary-group-watch-profile"
            [modelList]="watchProfileList"
            formControlName="watchProfile"
            [required]="isRequired('watchProfile')"
          >
          </app-watch-profile-autocomplete>
        </div>
      }

      <div>
        @if (!isNew) {
          <mat-datepicker #dummyDatePicker style="display: none"></mat-datepicker>
          @if (beneficiaryGroup.status.code === 'IN_PROGRAM') {
            <mat-form-field class="o100w-since">
              <mat-label>{{ beneficiaryGroup.status.description }} since</mat-label>
              <input
                name="100w-beneficiary-group-start-date"
                formControlName="startDate"
                matInput
                [matDatepicker]="dummyDatePicker"
              />
              <span matSuffix>({{ beneficiaryGroupHelper.getWeeksRunning(beneficiaryGroup) }} weeks)</span>
            </mat-form-field>
          }
          @if (beneficiaryGroup.status.code === 'OUT_OF_PROGRAM') {
            <mat-form-field class="o100w-since">
              <mat-label>{{ beneficiaryGroup.status.description }} since</mat-label>
              <input
                name="100w-beneficiary-group-end-date"
                formControlName="endDate"
                matInput
                [matDatepicker]="dummyDatePicker"
              />
              <span matSuffix
                >(ran for
                {{ beneficiaryGroupHelper.getWeeksRunning(beneficiaryGroup) }}
                weeks)</span
              >
            </mat-form-field>
          }
        }

        @if (nextStatus && showNextStatusDate) {
          <mat-form-field>
            <mat-label>Set {{ nextStatus | lowercase | replaceUnderscore }} date</mat-label>
            <input
              name="100w-beneficiary-group-next-status-date"
              formControlName="nextStatusDate"
              matInput
              [matDatepicker]="nextStatusDatePicker"
              (dateChange)="updateNextStatusRunningTime()"
            />
            @if (nextStatusRunningTime !== null) {
              <span matSuffix class="o100w-suffix-with-icon"> ({{ nextStatusRunningTime }} weeks) </span>
            }
            <mat-datepicker-toggle matSuffix [for]="nextStatusDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #nextStatusDatePicker [startAt]="nextStatusDatePickerStartDate"></mat-datepicker>
          </mat-form-field>
        }

        @if (!isNew && !showNextStatusDate && beneficiaryGroup.status?.code !== 'OUT_OF_PROGRAM') {
          <div class="filler"></div>
        }

        <mat-form-field class="o100w-max-running-time" *ngxPermissionsOnly="roleToEditPaymentData">
          <mat-label>running time</mat-label>
          <input
            name="100w-beneficiary-group-max-time"
            formControlName="maxRunningTime"
            matInput
            type="number"
            [required]="isRequired('maxRunningTime')"
            appEscalateInputChange
            entityName="BeneficiaryGroup"
            [entityUuid]="beneficiaryGroup.uuid"
            (changeRequestCreated)="reloadChangeRequests()"
          />
          <span matSuffix>&nbsp;weeks</span>
        </mat-form-field>

        <mat-form-field class="o100w-amount" *ngxPermissionsOnly="roleToEditPaymentData">
          <mat-label>payout amount</mat-label>
          <span matPrefix>€&nbsp;</span>
          <input
            name="100w-beneficiary-group-amount"
            formControlName="amount"
            matInput
            type="number"
            [min]="0"
            [required]="isRequired('amount')"
            appEscalateInputChange
            entityName="BeneficiaryGroup"
            [entityUuid]="beneficiaryGroup.uuid"
            currencySymbol="€"
            (changeRequestCreated)="reloadChangeRequests()"
          />
          <span matSuffix>&nbsp;per&nbsp;week</span>
        </mat-form-field>
      </div>

      <mat-card-actions>
        <button name="100w-beneficiary-group-button-back" mat-button type="button" (click)="back()">Back</button>
        <button
          name="100w-beneficiary-group-button-save"
          mat-raised-button
          type="submit"
          color="primary"
          *ngxPermissionsOnly="rolesToEdit"
          [disabled]="editForm.invalid"
        >
          Save
        </button>
        @if (nextStatus) {
          <button
            name="100w-beneficiary-group-button-{{ nextStatus }}"
            mat-raised-button
            type="button"
            (click)="updateToNextStatus()"
            color="primary"
            [disabled]="editForm.invalid || !canUpdateToNextStatus()"
          >
            {{ nextStatus | titlecase | replaceUnderscore }}
          </button>
        }
        @if (showDeleteBeneficiaries) {
          <ng-container *ngxPermissionsOnly="rolesToEdit">
            <button
              name="100w-beneficiary-group-button-delete-beneficiaries"
              mat-button
              type="button"
              (click)="deleteBeneficiaries()"
              matTooltip="This feature is only available on the TEST environment"
            >
              Delete beneficiaries [TEST]
            </button>
          </ng-container>
        }
      </mat-card-actions>
    </form>
  </mat-card-content>
</mat-card>

@if (!isNew) {
  <mat-card class="o100w-beneficiary-group-moneybar-card" appearance="outlined">
    <mat-card-header>
      <mat-card-title-group>
        <mat-card-title>Associated moneybar</mat-card-title>
      </mat-card-title-group>
    </mat-card-header>
    <mat-card-content>
      <app-moneybar-container class="moneybar-container" color="accent" [beneficiaryGroupUuid]="beneficiaryGroup.uuid">
      </app-moneybar-container>
      <app-moneybar-legend></app-moneybar-legend>
    </mat-card-content>
  </mat-card>
}

@if (!isNew) {
  <mat-card appearance="outlined">
    <mat-card-content>
      <mat-tab-group appBaseTabGroup>
        <mat-tab label="Beneficiaries">
          <ng-template mat-tab-label>
            Beneficiaries&nbsp;
            <mat-chip-listbox
              [matTooltip]="
                'Number of active beneficiaries / Number of beneficiaries that ' +
                (isLocked('onboardingGroupSize') ? 'were' : 'should be') +
                ' onboarded'
              "
            >
              @if (beneficiaryGroup.onboardingGroupSize) {
                <mat-chip
                  >{{ beneficiaryGroup.activeBeneficiaryCount }} / {{ beneficiaryGroup.onboardingGroupSize }}</mat-chip
                >
              }
              @if (!beneficiaryGroup.onboardingGroupSize) {
                <mat-chip>{{ beneficiaryGroup.activeBeneficiaryCount }}</mat-chip>
              }
            </mat-chip-listbox>
          </ng-template>
          <!-- matTabContent let the tab load data lazily -->
          <ng-template matTabContent>
            <mat-table
              [dataSource]="beneficiaryDataSource"
              matSort
              matSortDisableClear
              (matSortChange)="sortBeneficiaries($event)"
            >
              <ng-container matColumnDef="image">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let item">
                  <app-beneficiary-thumb [beneficiary]="item"></app-beneficiary-thumb>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="code">
                <mat-header-cell *matHeaderCellDef mat-sort-header>code</mat-header-cell>
                <mat-cell *matCellDef="let item">{{ item.code }}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="firstName">
                <mat-header-cell *matHeaderCellDef mat-sort-header="firstName">first name</mat-header-cell>
                <mat-cell *matCellDef="let item">{{ item.contact.firstName }}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef mat-sort-header="name">last name</mat-header-cell>
                <mat-cell *matCellDef="let item">{{ item.contact.name }}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="dateOfBirth">
                <mat-header-cell *matHeaderCellDef mat-sort-header>date of birth</mat-header-cell>
                <mat-cell *matCellDef="let item">{{ item.contact.dateOfBirth | date: 'dd-MM-yyyy' }}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef mat-sort-header>status</mat-header-cell>
                <mat-cell *matCellDef="let item">{{ item.status.description }}</mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="displayedBeneficiaryColumns; sticky: true"></mat-header-row>
              <mat-row
                *matRowDef="let row; columns: displayedBeneficiaryColumns"
                [routerLink]="['/beneficiaries', row.uuid]"
              ></mat-row>
            </mat-table>
          </ng-template>
        </mat-tab>
        <mat-tab label="Tasks">
          <ng-template mat-tab-label>
            Tasks&nbsp;
            @if (taskCount !== undefined) {
              <mat-chip-listbox>
                <mat-chip>{{ taskCount }}</mat-chip>
              </mat-chip-listbox>
            }
          </ng-template>
          <ng-template matTabContent>
            <app-task-table
              [dataSource]="taskDataSource"
              [displayedColumns]="displayedTaskColumns"
              [enableSort]="true"
              (sortChange)="sortTasks($event)"
            ></app-task-table>
          </ng-template>
        </mat-tab>
        @if (!isNew) {
          <mat-tab label="Comments">
            <!-- matTabContent let the tab load data lazily -->
            <ng-template matTabContent>
              <app-comment-table [dataSource]="commentDataSource"></app-comment-table>
            </ng-template>
          </mat-tab>
        }
        <mat-tab label="Files">
          <ng-template mat-tab-label>
            Files &nbsp;
            <mat-chip-listbox>
              <mat-chip>{{ assets.length }}</mat-chip>
            </mat-chip-listbox>
          </ng-template>
          <!-- matTabContent let the tab load data lazily -->
          <ng-template matTabContent>
            <app-asset-uploader
              (upload)="upload($event)"
              [multiple]="true"
              *ngxPermissionsOnly="rolesToEdit"
            ></app-asset-uploader>
            @if (assets) {
              <app-asset-grid-viewer
                [assets]="assets"
                (delete)="deleteAsset($event)"
                (change)="changeAsset($event.asset, $event.newDocumentType)"
                [rolesDocTypeChange]="rolesToEdit"
                [rolesRemove]="rolesToEdit"
              ></app-asset-grid-viewer>
            }
          </ng-template>
        </mat-tab>
        @if (!isNew) {
          <mat-tab label="Change Requests">
            <ng-template mat-tab-label>
              Change Requests &nbsp;
              <mat-chip-listbox>
                <mat-chip>{{ openChangeRequestCount }}</mat-chip>
              </mat-chip-listbox>
            </ng-template>
            <!-- matTabContent let the tab load data lazily -->
            <ng-template matTabContent>
              <app-change-request-table
                [dataSource]="changeRequestDataSource"
                (actionClick)="handleChangeRequestAction($event)"
              ></app-change-request-table>
            </ng-template>
          </mat-tab>
        }
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
}
